import React, { useEffect, useState } from "react";
import {
  convertRupeesToWords,
  roundOffCost,
} from "../../../Components/Functions/amt.fun";
import { getQuotationFor } from "../../../Components/Functions/word.fun";

const QuotationAmounts = ({ allQData, quotationType }) => {
  const [cost, setCost] = useState(0);
  const [unitcost, setUnitCost] = useState(0);
  const [overAllCost, setOverAllCost] = useState(cost);
  const [gstcost, setGstCost] = useState(0);
  const [amtinwords, setAMTInWords] = useState("");
  const [showScope, setShowScope] = useState(false);
  const [hideScope, setHideScope] = useState("");

  const style = {
    border: "1px solid #181818",
    textAlign: "left",
    margin: "-2px",
    fontSize: "13px",
    borderCollapse: "collapse",
    padding: "0px 3px",
    paddingTop: "-2px",
  };
  useEffect(() => {
    // "fanpad",
    // "nvph",
    // "nethouse",
    // "fanpad with hydroponics",
    // "nvph with hydroponics",
    // "nethouse with hydroponics",
    // "hydroponics only",
    // "hydrobuild xs",
    // "hydrobuild mini",
    // "hydrobuild pro",
    let total = 0;
    if (+allQData?.input_info?.overrideUnitCost > 0) {
      total += +allQData?.input_info?.overrideUnitCost;
    } else {
      total = allQData?.quotationMatrixCost?.total_cost;
    }

    setCost(total);
    if (allQData?.input_info?.maxDiscount > 0) {
      let x = total + total * (allQData?.input_info?.maxDiscount / 100);
      setUnitCost(x / allQData?.area_in?.area_in_sqmeter);
    } else {
      setUnitCost(total / allQData?.area_in?.area_in_sqmeter);
    }
    if (
      allQData?.input_info?.addOnParticulars &&
      allQData?.input_info?.addOnParticularsPrice
    ) {
      total += +allQData?.input_info?.addOnParticularsPrice;
    }
    setOverAllCost(total);
    setGstCost((total * 18) / 100);
    setAMTInWords(convertRupeesToWords(total + total * 0.18));
  }, [allQData]);

  useEffect(() => {
    if (allQData?.input_info?.quotationType === "hydroponics only") {
      setHideScope("CEA");
    }
    if (
      allQData?.input_info?.quotationType === "nvph" ||
      allQData?.input_info?.quotationType === "fanpad" ||
      allQData?.input_info?.quotationType === "nethouse" ||
      allQData?.input_info?.quotationType === "soilbasedfanpad" ||
      allQData?.input_info?.quotationType === "soilbasednvph" ||
      allQData?.input_info?.quotationType === "soilbasednethouse"
    ) {
      setHideScope("Hydroponic");
    }
    if (
      allQData?.input_info?.growBagPercent > 0 ||
      allQData?.input_info?.dutchBucketPercent > 0
    ) {
      setShowScope(true);
    }
  }, [allQData]);
  let serial = 1;
  useEffect(() => {
    if (allQData?.input_info?.isGrowSlab)
      setTimeout(() => {
        const elements = document.getElementsByClassName("gb-div");
        for (let element of elements) {
          element.innerHTML = element.innerHTML.replace(
            "GROW-BAG",
            "GROW-SLAB"
          );
          element.innerHTML = element.innerHTML.replace(
            "Grow bag",
            "Grow slab"
          );
          element.innerHTML = element.innerHTML.replace(
            "grow bags",
            "grow slabs"
          );
          element.innerHTML = element.innerHTML.replace(
            "Grow bags",
            "Grow slabs"
          );
          element.innerHTML = element.innerHTML.replace(
            "Grow Bags",
            "Grow Slabs"
          );
          element.innerHTML = element.innerHTML.replace(
            "Grow Bag",
            "Grow Slab"
          );
          element.innerHTML = element.innerHTML.replace("Growbag", "Growslab");
          element.innerHTML = element.innerHTML.replace(
            "Growbags",
            "Growslabs"
          );
          element.innerHTML = element.innerHTML.replace(
            "growbags",
            "growslabs"
          );
        }
      }, 1000);
  }, [allQData]);

  return (
    <div className="gb-div">
      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          margin: 0,
          padding: 0,
          borderBottom: "1px solid black",
          borderTop: "1px solid black",
        }}
      >
        <div>
          <p
            style={{
              margin: 0,
            }}
          >
            Business / Person name:
            {allQData?.input_info?.businessName ||
              allQData?.input_info?.contactPersonName}
            <br />
            Contact Person: {allQData?.input_info?.contactPersonName} <br />
            GSTIN: {allQData?.input_info?.gstNumber || "N/A"}
          </p>
        </div>
        <div>
          <p
            style={{
              margin: 0,
            }}
          >
            Quotation number: <b>{allQData?.quotationNumber}</b> <br />
            Date: {allQData?.input_info?.quotationDate} <br />
            Address: {allQData?.input_info?.address} <br />
          </p>
        </div>
      </div>

      <h3 style={{ textAlign: "center", margin: 0 }}>
        Quotation: Material + Installation
      </h3>
      <p style={{ textAlign: "center" }}>
        As Per “Development of Commercial Horticulture” of National Horticulture
        Board (NHB)
      </p>

      <table style={{ width: "100%" }}>
        <tbody>
          <tr>
            <th style={{ width: "4%" }}>Sr.</th>
            <th style={{ width: "40%" }}>Particulars</th>
            <th style={{ width: "15%" }}>Size/Unit</th>
            <th style={{ width: "11%" }}>Rates</th>
            <th style={{ width: "5%" }}>Disc</th>
            <th style={{ width: "10%" }}>Revised</th>
            <th style={{ width: "15%" }}>Amount</th>
          </tr>
          <tr>
            <td>{serial++}.</td>
            <td>
              {allQData?.input_info && getQuotationFor(allQData?.input_info)}
            </td>

            <td>{allQData?.area_in?.area_in_sqmeter} SqM</td>
            <td>{roundOffCost(unitcost / 0.9)}</td>
            <td>10%</td>
            <td>{roundOffCost(unitcost)}</td>
            {allQData?.input_info?.maxDiscount > 0 && (
              <td>
                {" "}
                {roundOffCost(
                  cost + cost * (allQData?.input_info?.maxDiscount / 100)
                )}
              </td>
            )}
            {allQData?.input_info?.maxDiscount == 0 && (
              <td> {roundOffCost(cost)}</td>
            )}
          </tr>

          {allQData?.input_info?.addOnParticulars && (
            <tr>
              <td>{serial++}.</td>
              <td>{allQData?.input_info?.addOnParticulars}</td>

              <td>{allQData?.area_in?.area_in_sqmeter} SqM</td>
              {/* <td>{roundOffCost((unitcost * 1.1) / 100)}</td> */}

              <td>
                {" "}
                {allQData?.input_info?.addOnParticularsPrice
                  ? roundOffCost(
                      +allQData?.input_info?.addOnParticularsPrice /
                        +allQData?.area_in?.area_in_sqmeter /
                        0.9
                    )
                  : roundOffCost(0)}
              </td>

              <td>10%</td>
              <td>
                {allQData?.input_info?.addOnParticularsPrice
                  ? roundOffCost(
                      +allQData?.input_info?.addOnParticularsPrice /
                        +allQData?.area_in?.area_in_sqmeter
                    )
                  : roundOffCost(0)}
              </td>
              <td>
                {allQData?.input_info?.addOnParticularsPrice
                  ? roundOffCost(+allQData?.input_info?.addOnParticularsPrice)
                  : roundOffCost(0)}
              </td>
            </tr>
          )}
          {hideScope !== "CEA" &&
            quotationType !== "nvph" &&
            quotationType !== "fanpad" &&
            quotationType !== "soilbasedfanpad" &&
            quotationType !== "soilbasednvph" && (
              <tr>
                <td>{serial++}.</td>
                <td>Retractable aluminium net</td>

                <td>{allQData?.area_in?.area_in_sqmeter} SqM</td>
                {/* <td>{roundOffCost((unitcost * 1.1) / 100)}</td> */}

                <td>{roundOffCost(30.2)}</td>
                <td>100%</td>
                <td>{roundOffCost(0)}</td>
                <td>{roundOffCost(0)}</td>
              </tr>
            )}
          {hideScope !== "CEA" &&
            quotationType !== "nvph" &&
            quotationType !== "fanpad" &&
            quotationType !== "soilbasedfanpad" &&
            quotationType !== "soilbasednvph" && (
              <tr>
                <td>{serial++}.</td>
                <td>Ground cover weedmat (150 gsm)</td>
                <td>{allQData?.area_in?.area_in_sqmeter} SqM</td>
                {/* <td>{roundOffCost((unitcost * 1.2) / 100)}</td> */}
                <td>{roundOffCost(18.6)}</td>
                <td>100%</td>
                <td>{roundOffCost(0)}</td>
                <td>{roundOffCost(0)}</td>
              </tr>
            )}
          {hideScope !== "CEA" && (
            <tr>
              <td>{serial++}.</td>
              <td>Insect net on four sides</td>
              <td>{allQData?.area_in?.area_in_sqmeter} SqM</td>
              <td>{roundOffCost((unitcost * 0.9) / 100)} </td>
              <td>100%</td>
              <td>{roundOffCost(0)}</td>
              <td>{roundOffCost(0)}</td>
            </tr>
          )}
          {hideScope !== "CEA" && (
            <tr>
              <td>{serial++}.</td>
              <td>Bottom Skirting on four sides</td>
              <td>{allQData?.area_in?.area_in_sqmeter} SqM</td>
              <td>{roundOffCost((unitcost * 0.9) / 100)} </td>
              <td>100%</td>
              <td>{roundOffCost(0)}</td>
              <td>{roundOffCost(0)}</td>
            </tr>
          )}
          {hideScope !== "Hydroponic" && showScope && (
            <tr
              style={{
                border: "1px solid black",
              }}
            >
              <td
                style={{
                  border: "1px solid black",
                }}
              >
                {serial++}.
              </td>
              <td
                style={{
                  border: "1px solid black",
                }}
              >
                Trellising (Growbag/Dutch Bucket)
              </td>
              <td
                style={{
                  border: "1px solid black",
                }}
              >
                {allQData?.area_in?.area_in_sqmeter} SqM
              </td>
              <td
                style={{
                  border: "1px solid black",
                }}
              >
                {roundOffCost((unitcost * 1.5) / 100)}
              </td>
              <td
                style={{
                  border: "1px solid black",
                }}
              >
                100%
              </td>
              <td
                style={{
                  border: "1px solid black",
                }}
              >
                {roundOffCost(0)}
              </td>
              <td
                style={{
                  border: "1px solid black",
                }}
              >
                {roundOffCost(0)}
              </td>
            </tr>
          )}
          <tr>
            <td>{serial++}.</td>
            <td>Erection & commissioning</td>
            <td>{allQData?.area_in?.area_in_sqmeter} SqM</td>
            {/* <td>{roundOffCost((unitcost * 8.5) / 100)}</td> */}
            <td>{roundOffCost(55.0)}</td>
            <td>100%</td>
            <td>{roundOffCost(0)}</td>
            <td>{roundOffCost(0)}</td>
          </tr>
          {hideScope !== "CEA" &&
            quotationType !== "nvph" &&
            quotationType !== "fanpad" &&
            quotationType !== "soilbasedfanpad" &&
            quotationType !== "soilbasednvph" && (
              <tr>
                <td>{serial++}.</td>
                <td>Timer controlled foggers</td>
                <td>1 Unit</td>
                <td>{roundOffCost(2500.0)}</td>
                <td>100%</td>
                <td>{roundOffCost(0)}</td>
                <td>{roundOffCost(0)}</td>
              </tr>
            )}
          {/* {hideScope !== "Hydroponic" && (
            <tr>
              <td>{serial++}.</td>
              <td>Ultra violet light disinfection </td>
              <td>1 Unit</td>
              <td>{roundOffCost(12000.0)}</td>
              <td>100%</td>
              <td>{roundOffCost(0)}</td>
              <td>{roundOffCost(0)}</td>
            </tr>
          )} */}
          {/* <tr>
            <td>{serial++}.</td>
            <td>Electric control panel</td>

            <td>1 Unit</td>
            <td>{roundOffCost(9400.00)}</td>
            <td>100%</td>
            <td>{roundOffCost(0)}</td>
            <td>{roundOffCost(0)}</td>
          </tr> */}
          {hideScope !== "CEA" && (
            <tr>
              <td>{serial++}.</td>
              <td>Decontamination cabin (Dooble door)</td>

              <td>1 Unit</td>
              <td>{roundOffCost(24000.0)}</td>
              <td>100%</td>
              <td>{roundOffCost(0)}</td>
              <td>{roundOffCost(0)}</td>
            </tr>
          )}
          {hideScope !== "CEA" && (
            <tr>
              <td>{serial++}.</td>
              <td>Mechanical geared vent opener</td>

              <td>4 Units</td>
              <td>{roundOffCost(2800.0)}</td>
              <td>100%</td>
              <td>{roundOffCost(0)}</td>
              <td>{roundOffCost(0)}</td>
            </tr>
          )}

          <tr>
            <td>{serial++}.</td>
            <td>CME report documentation</td>
            <td>1 Unit</td>
            <td>{roundOffCost(2500.0)}</td>
            <td>100%</td>
            <td>{roundOffCost(0)}</td>
            <td>{roundOffCost(0)}</td>
          </tr>
          {hideScope == "CEA" && (
            <>
              <tr>
                <td>{serial++}.</td>
                <td>
                  <b>Offer 1: Virtual agronomy (6 Month)</b>
                </td>

                <td>{allQData?.area_in?.area_in_sqmeter} SqM</td>
                <td>{roundOffCost(60000.0)}</td>
                <td>100%</td>
                <td>{roundOffCost(0)}</td>
                <td>{roundOffCost(0)}</td>
              </tr>
              <tr>
                <td>{serial++}.</td>
                <td>
                  <b>Offer 2: Buyers connect </b>
                </td>

                <td>1 User</td>
                <td>{roundOffCost(799.0)}</td>
                <td>100%</td>
                <td>{roundOffCost(0)}</td>
                <td>{roundOffCost(0)}</td>
              </tr>
              <tr>
                <td>{serial++}.</td>
                <td>
                  <b>Offer 3: Masterclass login</b>
                </td>

                <td>3 Users</td>
                <td>{roundOffCost(2499.0)}</td>
                <td>100%</td>
                <td>{roundOffCost(0)}</td>
                <td>{roundOffCost(0)}</td>
              </tr>
              <tr>
                <td>{serial++}.</td>
                <td>
                  <b>Offer 4: NHB/NHM/AIM DPR</b>
                </td>

                <td>1 File</td>
                <td>{roundOffCost(3500.0)}</td>
                <td>100%</td>
                <td>{roundOffCost(0)}</td>
                <td>{roundOffCost(0)}</td>
              </tr>
              <tr>
                <td>{serial++}.</td>
                <td>
                  <b>Offer 5: 8 Days hands-on labour training</b>
                </td>

                <td>2 Users</td>
                <td>{roundOffCost(20000.0)}</td>
                <td>100%</td>
                <td>{roundOffCost(0)}</td>
                <td>{roundOffCost(0)}</td>
              </tr>
              <tr>
                <td>{serial++}.</td>
                <td>
                  <b>Offer 6: Farm management software</b>
                </td>

                <td>2 years</td>
                <td>{roundOffCost(45000.0)}</td>
                <td>100%</td>
                <td>{roundOffCost(0)}</td>
                <td>{roundOffCost(0)}</td>
              </tr>
            </>
          )}

          {/* <% end %> */}
        </tbody>
      </table>
      <table style={{ width: "100%", border: "none" }}>
        <tbody>
          <tr>
            <td style={{ border: "none", width: "70%" }}>
              <div style={{ paddingTop: "3px" }}>
                {hideScope == "CEA" && (
                  <>
                    <b>
                      SAVE EXTRA FLAT {roundOffCost(131798.0)} BY AVAILING WITH
                      LIMITED TIME OFFERS(Already applied).
                    </b>
                    <br />
                  </>
                )}

                {amtinwords && (
                  <div
                    style={{
                      paddingBottom: "8px",
                      margin: "auto",
                      marginTop: "opx",
                    }}
                  >
                    In Words: <b> {amtinwords}</b>
                  </div>
                )}
              </div>

              {/* <% if record.currency.inr? %>
          In Words:
          <b><%= record.currency.format_value_in_words(record.calculator.total_amount_without_buyback_inc_gst) %></b>
        <% end %> */}
            </td>
            <td
              style={{
                border: "none",
                width: "30%",
                paddingRight: "0px",
                paddingLeft: "0px",
              }}
            >
              <table style={{ width: "100%" }}>
                <tbody>
                  {allQData?.input_info?.maxDiscount > 0 && (
                    <>
                      {" "}
                      <tr>
                        <td style={{ width: "50%" }}>Amount</td>
                        <td style={{ width: "50%" }}>
                          {roundOffCost(
                            cost +
                              cost * (allQData?.input_info?.maxDiscount / 100)
                          )}
                        </td>
                      </tr>
                      <tr>
                        <td style={{ width: "50%" }}>Sales Discount</td>
                        <td style={{ width: "50%" }}>
                          {roundOffCost(allQData?.input_info?.maxDiscount)}%
                        </td>
                      </tr>
                    </>
                  )}
                  <tr>
                    <td style={{ width: "50%" }}>Disc. Amount</td>
                    <td style={{ width: "50%" }}>
                      {roundOffCost(overAllCost)}
                    </td>
                  </tr>
                  <tr>
                    <td>GST 18%</td>
                    <td>{roundOffCost(gstcost)}</td>
                  </tr>
                  <tr>
                    <td>Total</td>
                    <td>{roundOffCost(overAllCost + gstcost)}</td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default QuotationAmounts;
